export enum paymentLinkStatus {
  active,
  deactivated,
}
